/**
 * Grading table colors — inline styles via `--grading-scoring-*` tokens
 * (same hue as KPI labels/values and grade confirmed icons).
 */

import type { CSSProperties } from "react"
import type { StatusBadgeTone } from "@/lib/list-status-badges"

export const GRADING_SCORING_COLOR = {
  needs: "var(--grading-scoring-needs)",
  ready: "var(--grading-scoring-ready)",
  released: "var(--grading-scoring-released)",
} as const

export const GRADING_TABLE_DOT_STYLE: Record<StatusBadgeTone, CSSProperties> = {
  warning: { backgroundColor: GRADING_SCORING_COLOR.needs },
  info: { backgroundColor: GRADING_SCORING_COLOR.ready },
  success: { backgroundColor: GRADING_SCORING_COLOR.released },
  danger: { backgroundColor: "var(--destructive)" },
  neutral: {
    backgroundColor: "color-mix(in oklch, var(--muted-foreground) 45%, transparent)",
  },
}

export const GRADING_TABLE_SCORE_EARNED_STYLE: CSSProperties = {
  color: GRADING_SCORING_COLOR.released,
}

/** Provisional partial totals — matches the completion ring and Partially scored badge. */
export const GRADING_TABLE_SCORE_PARTIAL_EARNED_STYLE: CSSProperties = {
  color: "var(--chip-4)",
}

/** Partial completion ring — same hue as Partially scored StatusBadge (warning / chip-4). */
export const GRADING_PARTIAL_RING_STROKE = "var(--chip-4)"

export const GRADING_PARTIAL_RING_TRACK: CSSProperties = {
  stroke: "color-mix(in oklch, var(--chip-4) 28%, transparent)",
}

export const GRADING_TABLE_GRADE_CONFIRMED_STYLE: CSSProperties = {
  color: GRADING_SCORING_COLOR.released,
}

export const GRADING_TABLE_GRADE_PENDING_STYLE: CSSProperties = {
  color: "var(--grading-grade-pending-icon)",
}

export const GRADING_TABLE_DISCARDED_FG_STYLE: CSSProperties = {
  color: "var(--grading-table-discarded-fg)",
}
